export default __webpack_public_path__ + "static/media/cosmonaute-3-new.041a347d.png";